
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate/transunion-mortgage",
      function () {
        return require("private-next-pages/affiliate/transunion-mortgage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate/transunion-mortgage"])
      });
    }
  